import React from 'react'
import RawHtml from '../RawHtml/react.js'
import { stripHtml } from 'Data/format.js'
import './style.css'

let FONT_SIZE = 13
let LINE_HEIGHT = 18
let COLOR = 'black'

function textLineBreaksToHtml(text = '') {
  return text.replace(/\r?\n/g, '<br/>')
}

function removeLineBreaksAfterHeadings(text = '') {
  // Remove single line break after closing heading tags to prevent double spacing
  return text.replace(/(<\/h[1-6]>)\n/g, '$1')
}

function mdHeadingToHtml(text = '') {
  // convert ### Heading to <h3>Heading</h3>
  // Handles h1 through h6
  return text.replace(
    /^(#{1,6})\s+(.+?)$/gm,
    function (match, hashes, content) {
      let level = hashes.length
      return `<h${level}>${content}</h${level}>`
    }
  )
}

function mdBoldToHtml(text = '') {
  // convert **<text>** to <strong>text</strong>
  return text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
}

function mdLinkToHtml(text = '') {
  // convert [link text](link) to <a href="link">link text</a>
  return text.replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2">$1</a>')
}

function processMarkdown(text) {
  return textLineBreaksToHtml(
    removeLineBreaksAfterHeadings(
      mdLinkToHtml(mdBoldToHtml(mdHeadingToHtml(text)))
    )
  )
}

export default function MarkdownHtml(props) {
  return (
    <div
      style={{
        '--color': `${props.color ?? COLOR}`,
        '--font-size': `${props.fontSize ?? FONT_SIZE}px`,
        '--line-height': `${props.lineHeight ?? LINE_HEIGHT}px`,
      }}
      className="markdown-html"
    >
      <RawHtml html={processMarkdown(stripHtml(props.markdown))}></RawHtml>
    </div>
  )
}
